import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import Share from './Share';
import { ReactComponent as ShareIcon } from './../../../assets/icons/ShereI.svg';
import { shareWithNativeOrPopup } from '../../../utils/nativeShare';
import { useSendStoreLogs } from '../../../hooks/StoreLogs/useSendStoreLogs';

/**
 * Controlled share button (parent may also trigger open via open/onOpen).
 * On mobile with Web Share API → native sheet; otherwise custom popup.
 */
const ShareButton = ({
  main_url,
  name,
  anchorEl: controlledAnchor,
  open: controlledOpen,
  onClose,
  onOpen,
  ...sx
}) => {
  const { storeLogs: sendLogs } = useSendStoreLogs();
  const [internalAnchor, setInternalAnchor] = useState(null);

  const isControlled = controlledOpen !== undefined;
  const anchorEl = isControlled ? controlledAnchor : internalAnchor;
  const open = isControlled ? Boolean(controlledOpen) : Boolean(internalAnchor);

  const closePopup = () => {
    if (isControlled) {
      onClose?.();
    } else {
      setInternalAnchor(null);
    }
  };

  const openPopup = (event) => {
    const target = event?.currentTarget || null;
    if (isControlled) {
      onOpen?.(event);
    } else {
      setInternalAnchor(target);
    }
  };

  const handleClick = async (event) => {
    event.stopPropagation();
    event.preventDefault();

    // If popup already open (desktop toggle), close it
    if (open) {
      closePopup();
      return;
    }

    const result = await shareWithNativeOrPopup({
      name,
      url: main_url,
      openPopup: () => openPopup(event),
    });

    if (result === 'shared') {
      sendLogs('shares');
    }
  };

  return (
    <>
      <IconButton sx={{ ...sx }} onClick={handleClick}>
        <ShareIcon className="svg" />
      </IconButton>
      <Share
        anchorEl={anchorEl}
        open={open}
        onClose={closePopup}
        main_url={main_url}
        name={name}
      />
    </>
  );
};

export default ShareButton;
